import { useTheme } from '@mui/material'

import { IconProps } from '@f-fertighaus/applications/Next/types/icon'

export const PercentSignIcon = (props: IconProps) => {
  const theme = useTheme()
  const stroke = props.color || theme.palette.primary.main
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='48'
      height='51'
      viewBox='0 0 48 51'
      fill='none'>
      <path
        d='M38.8052 4.87218L40.1633 13.5789L47.9777 17.6165L44.0371 25.5113L48 33.406L40.1187 37.4436L38.7607 46.1504L30.1002 44.7744L23.9332 51L17.744 44.6842L9.15028 46.1278L7.76994 37.3534L0 33.3384L3.96289 25.4436L0.0222634 17.6165L7.83673 13.5338L9.1948 4.89474L17.8108 6.33835L24 0L30.167 6.24812L38.8052 4.87218ZM18.4341 14.2331C17.5484 14.2331 16.699 14.5896 16.0727 15.2241C15.4465 15.8586 15.0946 16.7192 15.0946 17.6165C15.0946 18.5139 15.4465 19.3745 16.0727 20.009C16.699 20.6435 17.5484 21 18.4341 21C19.3198 21 20.1692 20.6435 20.7955 20.009C21.4218 19.3745 21.7737 18.5139 21.7737 17.6165C21.7737 16.7192 21.4218 15.8586 20.7955 15.2241C20.1692 14.5896 19.3198 14.2331 18.4341 14.2331ZM29.5659 30.0226C28.6802 30.0226 27.8307 30.379 27.2045 31.0136C26.5782 31.6481 26.2263 32.5087 26.2263 33.406C26.2263 34.3034 26.5782 35.164 27.2045 35.7985C27.8307 36.433 28.6802 36.7895 29.5659 36.7895C30.4516 36.7895 31.301 36.433 31.9273 35.7985C32.5535 35.164 32.9054 34.3034 32.9054 33.406C32.9054 32.5087 32.5535 31.6481 31.9273 31.0136C31.301 30.379 30.4516 30.0226 29.5659 30.0226ZM16.0074 36.7895L35.1317 17.4135L31.9926 14.2331L12.8683 33.609L16.0074 36.7895Z'
        fill={stroke}
      />
    </svg>
  )
}
